import React from 'react';
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button';
import { useEffect } from 'react'
import { Separator } from '@/components/ui/separator';


function Colofon() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className='mx-auto max-w-prose my-12 font-gotham text-medium text-start px-8'>
        {/*       <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Jaar 1</tag> */}
        <h1 className='my-6'>Privacy Statement</h1>
        <p className='my-6'>
  This website uses Vercel Analytics to gain insight into how the site is used. Vercel Analytics operates without cookies and does not collect any personally identifiable information. The system only records anonymized data, such as page views, device and browser type, and general performance statistics. This information is used to improve the functionality and user experience of the website.
  <br></br><br></br>
  Furthermore, no personal data is collected, stored, or shared through this website. We do not use tracking cookies, forms, marketing tools, or external trackers.
  <br></br><br></br>
  The website is hosted by Vercel, where standard server logs may be stored for security and error-tracking purposes. These logs may include IP addresses, but they are automatically anonymized and not used to identify visitors.
  <br></br><br></br>
  If you have any questions about this privacy statement, you can contact us via:<br></br><br></br>

  Cypher Studio<br></br>
  hello@cypherstudio.org
</p>


      </div>



    </>
  );
}

export default Colofon;